import BlockedAssignmentQuestion from 'client/components/QuestionTypes/BlockedAssignmentQuestion/BlockedAssignmentQuestion';
import {getRendererForQuestion} from 'components/QuestionTypes/getRendererForQuestion';
import React from 'react';
// import {Store} from 'client/framework'; TODO-KBC: Build typescript methods

interface Props {
  actions?: React.ReactNode;
  activeGuess?: any;
  activeQuestion: any;
  activeQuestionSet?: any;
  activeQuestionStore?: any; // PropTypes.instanceOf(Store) TODO-KBC: Build typescript methods
  activeSubject?: any;
  answerInputPaneRef?: React.RefObject<HTMLDivElement>;
  customHeader?: any;
  displayOrientation?: 'default' | 'vertical' | 'horizontal';
  hasHeading?: boolean;
  headingActions?: React.ReactNode;
  interactive?: boolean;
  isMobile?: boolean;
  modifyTitle?: () => {};
  navigateBackProps?: {[key: string]: any} | null;
  navigateNextProps?: {[key: string]: any} | null;
  onResize?: (resizerPosition: number) => void;
  postSubmissionScrollPointRef?: {[key: string]: any};
  rendererType?: 'PreGuess' | 'PostGuess' | 'Dennis';
  resizerPosition?: number;
  showDifficulty?: boolean;
  stackedContainerRef?: React.RefObject<HTMLDivElement>;
  hasQuestionSetAccessPredicate?: (questionSet: any) => boolean;
  partialCreditEnabled?: boolean;
  shouldSetContentMaxWidth?: boolean;
  useAdaptiveResizer?: boolean;
  shouldShowCopyright?: boolean;
}

const QuestionRenderer = ({
  actions,
  activeGuess,
  activeQuestion,
  activeQuestionSet,
  activeQuestionStore,
  activeSubject,
  answerInputPaneRef,
  customHeader,
  displayOrientation = 'default',
  hasHeading = true,
  headingActions,
  interactive,
  isMobile,
  modifyTitle,
  navigateBackProps,
  navigateNextProps,
  onResize,
  postSubmissionScrollPointRef,
  rendererType,
  resizerPosition,
  showDifficulty,
  stackedContainerRef,
  hasQuestionSetAccessPredicate,
  partialCreditEnabled = false,
  shouldSetContentMaxWidth,
  useAdaptiveResizer,
  shouldShowCopyright
}: Props) => {
  const Renderer = activeQuestion.getMeta().isBlockedAssignmentQuestion?.()
    ? BlockedAssignmentQuestion
    : getRendererForQuestion(activeQuestion)[rendererType];
  return (
    <Renderer
      actions={actions}
      activeQuestion={activeQuestion}
      activeQuestionSet={activeQuestionSet}
      activeQuestionStore={activeQuestionStore}
      answerInputPaneRef={answerInputPaneRef}
      resizerPosition={resizerPosition}
      displayOrientation={displayOrientation}
      isMobile={isMobile}
      onResize={onResize}
      guess={activeGuess}
      activeSubject={activeSubject || null}
      showDifficulty={showDifficulty}
      customHeader={customHeader || null}
      hasHeading={hasHeading}
      headingActions={headingActions}
      interactive={interactive}
      modifyTitle={modifyTitle}
      navigateBackProps={navigateBackProps}
      navigateNextProps={navigateNextProps}
      postSubmissionScrollPointRef={postSubmissionScrollPointRef}
      stackedContainerRef={stackedContainerRef}
      hasQuestionSetAccessPredicate={hasQuestionSetAccessPredicate}
      partialCreditEnabled={partialCreditEnabled}
      shouldSetContentMaxWidth={shouldSetContentMaxWidth}
      useAdaptiveResizer={useAdaptiveResizer}
      shouldShowCopyright={shouldShowCopyright}
    />
  );
};

export default QuestionRenderer;
